<template>
    <!-- Camino de Santiago pilgrim with backpack and staff, flat white;
         the shirt takes the team colour. -->
    <svg class="theme-rider rider-camino" :class="{ 'rider-moving': moving }" viewBox="0 0 44 44" :width="size * 44 / 64" :height="size * 44 / 64" aria-hidden="true">
        <g class="rider-body">
            <path class="rider-staff" d="M30.5 6 L32 43" />
            <circle class="rider-gourd" cx="30.6" cy="10.5" r="1.7" />
            <rect class="rider-pack" x="11.5" y="12" width="7" height="12" rx="2.2" />
            <path class="rider-limb rider-limb-back" d="M20 25 L16.5 34 L12.5 42" />
            <path class="rider-accent-edge" d="M21 13 L20 25" />
            <path class="rider-accent" :style="{ stroke: color }" d="M21 13 L20 25" />
            <path class="rider-limb" d="M20 25 L25 33.5 L27.5 42.5" />
            <path class="rider-limb rider-arm" d="M21.5 14.5 L26.5 20.5 L31 19.5" />
            <circle class="rider-head" cx="22" cy="7.5" r="3.3" />
            <path class="rider-hat" d="M16.8 5.2 L27.4 5.2" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'CaminoRider',
    props: {
        color: { type: String, default: '#00a7af' },
        size: { type: Number, default: 56 },
        moving: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
    svg{ overflow: visible; }
    circle, path, rect{
        fill: none;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    .rider-staff{ stroke-width: 2; }
    .rider-gourd{ fill: #fff; stroke: none; }
    .rider-pack{ fill: #fff; stroke: none; }
    .rider-limb{ stroke-width: 3.4; }
    .rider-limb-back{ opacity: 0.6; }
    .rider-arm{ stroke-width: 2.8; }
    .rider-accent-edge{ stroke: rgba(0, 0, 0, 0.45); stroke-width: 9; }
    .rider-accent{ stroke-width: 7.4; }
    .rider-head{ fill: #fff; stroke: none; }
    .rider-hat{ stroke-width: 2.2; }
    .rider-moving .rider-body{ animation: rider-walk 0.5s ease-in-out infinite alternate; }
    @keyframes rider-walk{ to{ transform: translateY(-1.5px); } }
    @media (prefers-reduced-motion: reduce){
        .rider-moving .rider-body{ animation: none; }
    }
</style>
